<div class="accident-details-container" [ngClass]="{'mox-style': claim.isMox()}">
  <div class="prev-bar" *ngIf="!transactionInfo.hasSingleInsured()">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><em class="fas fa-arrow-left"></em> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
  </div>
  <div class="col-12">
    <h5>{{ 'paClaim.accidentDetails.title' | translate }}</h5>
    <br>
  </div>
  <div class="row col-12">
    <div class="col-lg-9 col-md-12">
      <form>
        <div class="form-group">
          <qnect-ui #PA_OCCUPATION [fieldId]="'PA_OCCUPATION'" [formGroup]="accidentDetailsForm" name="occupation"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="claimPA.getAccidentDetails().getOccupation() == 'Others'">
          <qnect-ui #PA_OCCUPATION_OTHERS [fieldId]="'PA_OCCUPATION_OTHERS'" [formGroup]="accidentDetailsForm" name="occupationOthers"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #PA_JOB_TITLE [fieldId]="'PA_JOB_TITLE'" [formGroup]="accidentDetailsForm" name="jobTitle"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #PA_ACCIDENT_DATE [fieldId]="'PA_ACCIDENT_DATE'" [formGroup]="accidentDetailsForm" name="accidentDate"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #PA_ACCIDENT_COUNTRY [fieldId]="'PA_ACCIDENT_COUNTRY'" [formGroup]="accidentDetailsForm" name="countryIncidentOccur"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #PA_ACCIDENT_ADDRESS_MAP [fieldId]="'PA_ACCIDENT_ADDRESS_MAP'" [formGroup]="accidentDetailsForm" name="accidentAddress"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #PA_ACCIDENT_DESCRIPTION [fieldId]="'PA_ACCIDENT_DESCRIPTION'" [formGroup]="accidentDetailsForm" name="accidentDescription"></qnect-ui>
        </div>
      </form>
    </div>
    <div class="col-lg-3 col-xl-3 col-md-12">
      &nbsp;
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary">{{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn btn-primary float-right new-btn">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<em class="fas fa-arrow-right"></em></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>

